// Foundations
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

// rxjs
import { map } from 'rxjs';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CamperCamsService } from 'src/app/services/camper-cams.service';
import { GetLocationGQL } from 'src/app/services/graphql.service';

@Component({
  selector: 'app-camper-cams-page',
  templateUrl: './camper-cams-page.component.html',
  styleUrls: ['./camper-cams-page.component.scss'],
})
export class CamperCamsPageComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'page-config';

  // 0 -> Step Two
  // 1 -> Change Location
  // 2 -> Search Location

  step = 0;

  constructor(
    private route: ActivatedRoute,
    private _analytics: AnalyticsService,
    private camperCamsService: CamperCamsService,
    private getLocationQuery: GetLocationGQL,
    private titleService: Title
  ) {
    this.titleService.setTitle('Client Portal - Camper Cams℠');
    const campId = this.route.snapshot.queryParams.campId;
    if (campId) {
      this.getLocationQuery
        .fetch({ locationId: campId })
        .pipe(map((res) => res.data.getLocation))
        .subscribe((location) => {
          if (location) {
            const {
              id,
              name,
              address1,
              address2,
              city,
              state,
              zipcode,
              country,
              email,
              telephone,
              websiteUrl,
              hoursOfOperation,
              code,
              creditCardProcessingEnabled,
            } = location;
            this.camperCamsService.selectedLocation = {
              id,
              name,
              address1,
              address2,
              city,
              state,
              zipcode,
              country,
              email,
              telephone,
              websiteUrl,
              hoursOfOperation,
              code,
              creditCardProcessingEnabled
            };
          }
        });
    }
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this._analytics.logScreen('camperCamsPage');
  }

  ngOnDestroy(): void {
    // clear selected location when user navigates away
    this.camperCamsService.selectedLocation = null;
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  handlePageContent(step): void {
    this.step = step;
  }
}
